import { MapTo } from '@adobe/aem-react-editable-components';
import HelpCenterArticleContainer, { HelpCenterArticleContainerEditConfig } from './HelpCenterArticleContainer';

export default MapTo('cob-corp-acquisition/components/creditonebank/help-center-article-container')(HelpCenterArticleContainer, HelpCenterArticleContainerEditConfig);